import React, { useState, useEffect } from 'react'

import { useAuth } from 'src/contexts/auth'
import { useNavigate } from 'react-router-dom'
import ROUTES from 'src/constants/routes'
import { Button, Loading } from 'src/components'
import { toast } from 'react-toastify'
import { useStyles } from './styles'
import { Checkbox } from '@material-ui/core'

export const Login: React.FC = () => {
  const { login, statusLogin, loading } = useAuth()

  const [username, setUsername] = useState('')
  const [senha, setSenha] = useState('')
  const [showPassword, setShowPassword] = useState(false)

  const style = useStyles()
  const navigate = useNavigate()

  const handleSubmit = (e) => {
    e.preventDefault()
    if (!username) {
      toast.error('E-mail não preenchido')
      return
    }
    if (!senha) {
      toast.error('Senha não preenchida')
      return
    }
    login(username, senha)
  }

  useEffect(() => {
    if (statusLogin === 'Erro') {
      setSenha('')
    }
  }, [statusLogin])

  return (
    <>
      {loading && <Loading className={style.loginLoading} />}
      <div className={style.loginContainer}>
        <div className={style.loginForm}>
          <div className={style.loginTitleWrapper}>
            <h1>CONGADO</h1>
          </div>
          <div className={style.loginInfoWrapper}>
            <h2>Entre com o seu Login</h2>
            <div className={style.loginWrapperInfo}>
              <p className={style.loginInfo}>Não tem uma conta?</p>
              <p onClick={() => navigate(ROUTES.AUTH.REGISTER)} className={style.loginRegister}>
                Cadastre-se
              </p>
            </div>
          </div>
          <form>
            <div className={style.loginInput}>
              <label>E-mail</label>
              <input
                id='login__username'
                name='username'
                value={username}
                placeholder='Email ou username'
                disabled={loading}
                onChange={(e) => setUsername(e.target.value)}
              />
            </div>
            <div className={style.loginInput}>
              <label>Senha</label>
              <input
                id='login__senha'
                type={showPassword ? 'text' : 'password'}
                name='senha'
                value={senha}
                placeholder='Digite sua senha'
                disabled={loading}
                onChange={(e) => setSenha(e.target.value)}
              />
            </div>
            <div className={style.loginShowPassword} onClick={() => setShowPassword(showPassword ? false : true)}>
              <Checkbox checked={true === showPassword} />
              <label>Mostrar Senha</label>
            </div>
            <Button type='submit' className='login__button' onClick={handleSubmit} disabled={loading}>
              Entrar
            </Button>
            <div className={style.loginForgotPassword}>
              <p onClick={() => navigate(ROUTES.AUTH.RESET_PASSWORD)}>Esqueceu sua senha?</p>
            </div>
          </form>
        </div>
        <div className={style.loginImageSide}></div>
      </div>
    </>
  )
}
